import React from "react";
import { useLang } from "../../contexts/LanguageContext";
import { t, tr } from "../../i18n/translations";
import { Instagram, MessageCircle, MapPin } from "lucide-react";

export default function Footer() {
  const { lang } = useLang();
  return (
    <footer className="bg-[#1A1A1A] text-[#FAFAFA] pt-24 pb-10" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <p className="overline text-[#8B6D5E] mb-6">{tr(t.contact.overline, lang)}</p>
        <h2 className="font-serif text-6xl sm:text-8xl lg:text-[10rem] leading-[0.95] tracking-tighter mb-16">
          {tr(t.footer.hablemos, lang)}
        </h2>

        <div className="grid lg:grid-cols-3 gap-10 lg:gap-16 border-t border-[#2a2a2a] pt-12">
          <div>
            <p className="overline text-[#8B6D5E] mb-4">Instagram</p>
            <a
              href="https://www.instagram.com/abrilsuamkp/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="flex items-center gap-3 font-serif text-3xl hover:text-[#8B6D5E] transition-colors"
            >
              <Instagram size={22} /> @abrilsuamkp
            </a>
          </div>
          <div>
            <p className="overline text-[#8B6D5E] mb-4">WhatsApp</p>
            <a
              href="https://wa.me/message/SG2ELRTG32LVF1"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="flex items-center gap-3 font-serif text-3xl hover:text-[#8B6D5E] transition-colors"
            >
              <MessageCircle size={22} /> {tr(t.contact.whatsapp, lang)}
            </a>
          </div>
          <div>
            <p className="overline text-[#8B6D5E] mb-4">Estudio</p>
            <p className="flex items-center gap-3 font-serif text-3xl">
              <MapPin size={22} /> {tr(t.contact.location, lang)}
            </p>
          </div>
        </div>

        <div className="border-t border-[#2a2a2a] mt-16 pt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-xs tracking-[0.2em] uppercase text-[#7c7c7c]">
            © {new Date().getFullYear()} Abril Suarez · {tr(t.footer.rights, lang)}
          </p>
          <div className="flex items-center gap-6">
            <a href="/vault" className="text-xs tracking-[0.2em] uppercase text-[#7c7c7c] hover:text-[#FAFAFA] link-underline" data-testid="footer-vault">
              Client Vault
            </a>
            <p className="text-xs tracking-[0.2em] uppercase text-[#7c7c7c]">{tr(t.footer.studio, lang)}</p>
          </div>
        </div>

        <div className="border-t border-[#2a2a2a] mt-6 pt-6 flex items-center justify-center">
          <a
            href="https://www.lumbreriastudio.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-lumbreria"
            className="text-xs tracking-[0.24em] uppercase text-[#7c7c7c] hover:text-[#FAFAFA] transition-colors"
          >
            Diseñado por <span className="text-[#8B6D5E]">Lumbreria Studios</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
